import script from "./ServiceSideView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ServiceSideView.vue?vue&type=script&setup=true&lang=ts"

import "./ServiceSideView.vue?vue&type=style&index=0&id=2825a382&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2825a382"]])

export default __exports__